module.exports = __webpack_public_path__ + "static/img/animales_13.e7e33415.jpg";